import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import chat from './chat';
import token from './token';
import loading from './loading';

export default new Vuex.Store({
	modules: {
		chat,
		token,
		loading
	}
})
